<template>
	<v-text-field
		outlined
		clearable
		single-line
		hide-details
		ref="search_field_ref"
		@blur="onBlur"
		v-model="localValue"
		@click:clear="onClear"
		@focus="isFocused = true"
		:placeholder="placeholder"
		prepend-inner-icon="mdi-magnify"
		clear-icon="mdi-close-circle-outline"
		:class="{ 'focused-background': isFocused }"
		class="search-action-text-field mt-2 width-100"
		:loading="loading"
	></v-text-field>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'AppActionSearchField',
	props: {
		searchString: { type: String, default: '' },
		placeholder: { type: String, default: 'Search' },
		loading: { type: Boolean },
	},
	methods: {
		onClear() {
			this.$emit('input', '');
			this.$emit('clear-focus');
		},
		onBlur() {
			this.isFocused = false;
			this.$emit('clear-focus');
		},
	},
	mixins: [VModelMixin],
	data() {
		return { isFocused: false };
	},
	mounted() {
		this.$refs.search_field_ref.focus();
		window.addEventListener('keydown', (event) => {
			if (this.isFocused) {
				if (event.keyCode === 40) {
					this.$emit('on-arrow-down');
				}
				if (event.keyCode === 38) {
					this.$emit('on-arrow-up');
				}
			}
		});
	},
};
</script>

<style scoped lang="scss">
.search-action-text-field {
	$re-margin-top: 7px;

	::v-deep {
		.v-input__prepend-inner {
			margin-top: $re-margin-top;
		}
		.v-input__append-inner {
			cursor: pointer;
			margin-top: $re-margin-top;
		}
	}
}
</style>
